import { render, staticRenderFns } from "./beans-goods.vue?vue&type=template&id=49bfd2f0&scoped=true"
import script from "./beans-goods.vue?vue&type=script&lang=js"
export * from "./beans-goods.vue?vue&type=script&lang=js"
import style0 from "./beans-goods.vue?vue&type=style&index=0&id=49bfd2f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bfd2f0",
  null
  
)

export default component.exports